export const routes = [{
    path: '/', //首页
    name: 'Home',
    component: function(resolve) {
      require(['../views/home'], resolve)
    }
  },
  {
    path: '/goods/:id',
    name: 'Goods', //商品详情页
    component: function(resolve) {
      require(['../views/goods'], resolve)
    }
  },
  {
    path: '/classify/:id/:subid', //商品分类
    component: function(resolve) {
      require(['../views/classify'], resolve)
    }
  },
  {
    path: '/activity/:id',
    name: 'Activity', //活动页
    component: function(resolve) {
      require(['../views/activity'], resolve)
    }
  },
  {
    path: '/cart',
    name: 'Cart', //购物车页面
    component: function(resolve) {
      require(['../views/cart'], resolve)
    }
  },
  {
    path: '/settlement/:id',
    name: 'Settlement', //订单结算页
    component: function(resolve) {
      require(['../views/settlement'], resolve)
    }
  },
  {
    path: '/cashier_desk/:sn',
    name: 'CahierDesk', //收银台
    component: function(resolve) {
      require(['../views/cashier_desk'], resolve)
    }
  },
  {
    path: '/product_list/:index',
    name: 'ProductList', //商品列表页
    component: function(resolve) {
      require(['../views/product_list'], resolve)
    }
  },
  {
    path: '/address/:id',
    name: 'Address', //收货地址页
    component: function(resolve) {
      require(['../views/address'], resolve)
    }
  },
  {
    path: '/add_address',
    name: 'AddAddress', //添加收货地址
    component: function(resolve) {
      require(['../views/edit_address'], resolve)
    }
  },
  {
    path: '/edit_address/:id',
    name: 'EditAddress', //编辑收货地址
    component: function(resolve) {
      require(['../views/edit_address'], resolve)
    }
  },
  {
    path: '/mine',
    name: 'Mine', //个人主页
    component: function(resolve) {
      require(['../views/mine'], resolve)
    }
  },
  {
    path: '/order/:type',
    name: 'MyOrder',  //订单列表页
    component: function(resolve) {
      require(['../views/order'], resolve)
    }
  },
  {
    path: '/order_detail/:sn',
    name: 'OrderDetail', //订单详情页
    component: function(resolve) {
      require(['../views/order_detail'], resolve)
    }
  },
  {
    path: '/balance/:tab',
    name: 'Balance', //余额页面
    component: function(resolve) {
      require(['../views/balance'], resolve)
    }
  },
  {
    path: '/card_buy',
    name: 'CardBuy', //充值卡购买
    component: function(resolve) {
      require(['../views/card_buy'], resolve)
    }
  },
  {
    path: '/my_coupon/:id',
    name: 'MyCoupon', //我的优惠券
    component: function(resolve) {
      require(['../views/my_coupon'], resolve)
    }
  },
  {
    path: '/my_package/:type',
    name: 'MyPackage', // 我的套餐
    component: function(resolve) {
      require(['../views/my_package'], resolve)
    }
  },
  {
    path: '/package/:id',
    name: 'PackageDetail', // 套餐设置详情页
    component: function(resolve) {
      require(['../views/package_detail'], resolve)
    }
  },
  {
    path: '/package_goods/:nav_id/:address_id',
    name: 'PackageGoods',  //套餐商品页
    component: function(resolve) {
        require(['../views/package-goods'], resolve)
    }
  },
  {
    path: '/edit_package/:order_id/:address_id',
    name: 'EditPackage',  //套餐编辑页
    component: function(resolve) {
        require(['../views/package-goods'], resolve)
    }
  },
  {
      path: '/package_address/:id',
      name: 'PackageAddress',  //套餐地址选择页
      component: function(resolve) {
          require(['../views/package_address'], resolve)
      }
  },
  {
      path: '/package_logs/:id',
      name: 'PackageLogs', //套餐日志页
      component: function(resolve) {
          require(['../views/package_logs'], resolve)
      }
  },
  {
      path: '/package_log_detail/:id',
      name: 'PackageLogDetail',
      component: function(resolve) {
          require(['../views/package_log_detail'], resolve)
      }
  },
  {
    path: '/setting',
    name: 'Setting', //个人信息编辑
    component: function(resolve) {
      require(['../views/setting'], resolve)
    }
  },
  {
    path: '/my_favor/:type',
    name: 'MyFavor', //我喜欢的
    component: function(resolve) {
      require(['../views/my_favor'], resolve)
    }
  },
  {
    path: '/group_purchase/:type',
    name: 'GroupPurchase', //团购
    component: function(resolve) {
      require(['../views/group_purchase'], resolve)
    }
  },
  {
    path: '/discover',
    name: 'Discover', //发现
    component: function(resolve) {
      require(['../views/discover'], resolve)
    }
  },
  {
    path: '/search',
    name: 'NoSearch', //搜索页面
    component: function(resolve) {
      require(['../views/search'], resolve)
    }
  },
  {
    path: '/search/:kw',
    name: 'Search',
    component: function(resolve) {
      require(['../views/search'], resolve)
    }
  },
  {
    path: '/login',
    name: 'Login', //登录页面
    component: function(resolve) {
      require(['../views/login'], resolve)
    }
  },
  {
    path: '/register',
    name: 'Register', //注册
    component: function(resolve) {
      require(['../views/login'], resolve)
    }
  },
  {
    path: '/password',
    name: 'Password', //找回密码
    component: function(resolve) {
      require(['../views/password'], resolve)
    }
  },
  {
    path: '/set_password/:type',
    name: 'SetPassword', //设置新密码
    component: function(resolve) {
      require(['../views/password'], resolve)
    }
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: function(resolve) {
        require(['../views/mobile'], resolve)
    }
  },
  {
    path: '/article/:cat_id',
    name: 'ArticleList', //文章列表
    component: function(resolve) {
      require(['../views/article'], resolve)
    }
  },
  {
    path: '/article_detail/:id',
    name: 'ArticleDetail', //文章详情
    component: function(resolve) {
        require(['../views/article_detail'], resolve)
    }
  },
  {
    path: '/farmers',
    name: 'Farmers', //农民列表
    component: function(resolve) {
        require(['../views/farmers'], resolve)
    }
  },
  {
    path: '/farmer/:id',
    name: 'Farmer',  //农民详情
    component: function(resolve) {
        require(['../views/farmer'], resolve)
    }
  },
  {
    path: '/standards/:id', //原味标准主id
    name: 'Standards', //原味标准列表页
    component: function(resolve) {
        require(['../views/standards'], resolve)
    }
  },
  {
    path: '/standard/:id/:sub_id', //原味标准主, 子id
    name: 'Standard',  //原味标准详情页
    component: function(resolve) {
        require(['../views/standard'], resolve)
    }
  },
  {
    path: '/recipes',
    name: 'Recipes', //食谱列表
    component: function(resolve) {
        require(['../views/recipes'], resolve)
    }
  },
  {
    path: '/recipe/:id',
    name: 'Recipe',   //食谱详情
    component: function(resolve) {
        require(['../views/recipe'], resolve)
    }
  },
  {
    path: '/events/:id',
    name: 'Events',  //特殊活动
    component: function(resolve) {
        require(['../views/events'], resolve)
    }
  },
  {
    path: '/about',
    name: 'About', //关于我们
    component: function(resolve) {
        require(['../views/about'], resolve)
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js